<div *ngIf="overallLabGuide" class="d-flex justify-content-between align-items-center border rounded p-3 shadow-sm" style="max-width: 100%; max-height: 75px;">
  <!-- Left Section -->
  <div class="d-flex align-items-center">
    <!-- Icon -->
     <div class="svg-icon"></div>
    <!-- Text -->
    <div>
      <h6 *ngIf="overallLabGuide?.TotalValidations > 0 && overallLabGuide?.TotalQuestions > 0" class="fw-bold mb-0">{{'QUESTIONS_LABEL' | translate}} & {{'VALIDATIONS' | translate}}</h6>
      <h6 *ngIf="overallLabGuide?.TotalValidations > 0 && overallLabGuide?.TotalQuestions === 0" class="fw-bold mb-0">{{'VALIDATIONS' | translate}}</h6>
      <h6 *ngIf="overallLabGuide?.TotalQuestions > 0 && overallLabGuide?.TotalValidations === 0" class="fw-bold mb-0">{{'QUESTIONS_LABEL' | translate}}</h6>
      <small class="text-muted">{{'OVERALL_POINTS' | translate}}</small>
    </div>
  </div>

  <!-- Points Box -->
  <div class="border rounded px-3 py-1 text-primary fw-semibold">
    <span class="text-primary">{{overallLabGuide?.AchievedLabScore}}</span>/<span class="text-secondary">{{overallLabGuide?.TotalLabScore}} {{'POINTS_LABEL' | translate}}</span>
  </div>
</div>
<div class="mt-4">
    <ul class="nav nav-pills mb-3 flex-nowrap pb-1" *ngIf="labQuestions || labValidation">
      <li [ngClass]="{'w-100':overallLabGuide?.TotalValidations > 0 && overallLabGuide?.TotalQuestions === 0, 'w-50': !(overallLabGuide?.TotalValidations > 0 && overallLabGuide?.TotalQuestions === 0)}" class="nav-item"  *ngIf="labValidation">
        <button 
          class="nav-link w-100" 
          [class.active]="activeTab === 'validation'" 
          (click)="setActiveTab('validation', voucherCode)">
          {{'VALIDATIONS' | translate}} {{labValidation[0]?.CompletedValidations}}/{{labValidation[0]?.TotalValidations}}
        </button>
      </li>
      <li [ngClass]="{'w-100':overallLabGuide?.TotalQuestions > 0 && overallLabGuide?.TotalValidations === 0,
        'w-50': !(overallLabGuide?.TotalQuestions > 0 && overallLabGuide?.TotalValidations === 0)}" class="nav-item"   *ngIf="labQuestions">
        <button 
          class="nav-link w-100" 
          [class.active]="activeTab === 'question'" 
          (click)="setActiveTab('question', voucherCode)">
          {{'QUESTIONS_LABEL' | translate}} {{labQuestions[0]?.completedQuestions}}/{{labQuestions[0]?.totalQuestions}}
        </button>
      </li>
    </ul>
  
    <div class="tab-content pt-3">
      <div *ngIf="activeTab === 'validation'" class="tab-pane fade show active">
        <ng-container *ngIf="labValidation && labValidation[0]?.ValidationViewModels?.length > 0">
          <cloudlabs-lab-validation [voucherCode]="voucherCode" 
              [arrValidation]="labValidation[0]?.ValidationViewModels"
              [isValidationProgress]="true" [isProgressCard]="true"
            >
          </cloudlabs-lab-validation>
        </ng-container>
      </div>
      <div *ngIf="activeTab === 'question'" class="tab-pane fade show active">
        <!-- Inline questions -->
        <ng-container *ngIf="labQuestions?.length > 0">
                                    
          <!-- Ungrouped questions -->
          <ng-container *ngIf="labQuestions[0]?.ungroupedQuestions?.length > 0">
            <ng-container *ngFor=" let ungroupQuestion of labQuestions[0]?.ungroupedQuestions; let i = index">
              <div class="position-relative">
                <cloudlabs-inline-question [questIndex]="i" 
                    [questionStyle]="'ungroupedQuest'"
                    [questionData]="ungroupQuestion"
                    [isProgressCard]="true">
                </cloudlabs-inline-question>
              </div>
            </ng-container>
              
          </ng-container>

          <!-- Grouped questions -->
          <div class="position-relative" *ngIf="labQuestions[0]?.groupedQuestions?.length > 0">
            <ng-container *ngFor=" let groupQuestion of labQuestions[0]?.groupedQuestions; let i = index">
              <cloudlabs-inline-question [questIndex]="i" 
                  [questionStyle]="'groupedQuest'"
                  [questionData]="groupQuestion"
                  [isProgressCard]="true">
              </cloudlabs-inline-question>
            </ng-container>
              
          </div>
        </ng-container>
      </div>
    </div>
</div>